"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var xssFilter = require("xss-filters");
var commonweb_utils_1 = require("commonweb-utils");
/**
 * @function interpolation - merges strings with associated dynamic values
 *
 * This function first iterates through the data values to ensure clean, non-
 * malicious code before injecting it into views.
 *
 * E.g.
 * 		content.greeting = 'Hello again, {name}!';
 * 		data.user.name = 'Jane';
 *
 * 		<p>{ i11n('inHTMLData', content.greeting, { name: data.user.name }) }</p>
 *
 * @param filter – should reflect the API options from https://github.com/yahoo/xss-filters/wiki
 * @param content - the string to interpolate
 * @param data - a *flat* map of data
 * @returns {string} - the interpolated string
 */
function i11n(filter, // 'inHTMLData' | 'inDoubleQuotedAttr' | 'inSingleQuotedAttr' | 'inUnQuotedAttr' |
// 'inHTMLComment' | 'uriInDoubleQuotedAttr' | 'uriInSingleQuotedAttr' | 'uriInUnQuotedAttr' ,
content, data // : { [key: string]: string }
) {
    if (!data && typeof data !== 'object') {
        return content;
    }
    var objectKeys = Object.keys(data);
    for (var i = 0; i < objectKeys.length; i++) {
        data[objectKeys[i]] = xssFilter[filter](data[objectKeys[i]]);
    }
    // In case string has double quotes, double escape them to prevent breaking safeInterpolate();
    // tslint:disable
    content = content.replace(/"/g, '\\"');
    // tslint:enable
    return commonweb_utils_1.objectUtils.safeInterpolate(content, data);
}
exports.default = i11n;
;
